import { boot } from "@/boot";

void boot();
